import React, { useState } from "react";
import { PlayCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";

const YoutubeVideoPlayer = ({ borderRadius = 0 }) => {
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const youtubeVideoId = "7c3PVU6LKTk";
  const thumbnailUrl = `https://img.youtube.com/vi/${youtubeVideoId}/maxresdefault.jpg`;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      <img
        src={thumbnailUrl}
        alt="Video Thumbnail"
        style={{ width: "100%", height: "auto", borderRadius }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          borderRadius,
        }}
        onClick={() => setOpenVideoModal((prev) => !prev)}
      >
        <div>
          <PlayCircleOutlined
            style={{
              fontSize: 55,
              color: "#fff",
            }}
          />
        </div>
      </div>
      {openVideoModal && (
        <ModalVideo
          youtubeVideoId={youtubeVideoId}
          onClose={() => setOpenVideoModal(false)}
        />
      )}
    </div>
  );
};

export default YoutubeVideoPlayer;

const ModalVideo = ({ youtubeVideoId, onClose }) => {
  const videoUrl = `https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1`;
  return (
    <Modal
      visible={true}
      closable={onClose}
      onCancel={onClose}
      footer={null}
      width="80%"
    >
      <iframe
        width={"100%"}
        style={{
          minHeight: window.innerHeight * 0.8,
        }}
        height="auto"
        src={videoUrl}
        title="YouTube Video Player"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
    </Modal>
  );
};
